/**
 * screen saver "abstract"
 */

'use strict';

// set webkit size
window.moveTo(0, 0);
window.resizeTo(screen.width, screen.height);

function canvasApp () {
    var theCanvas = document.createElement('canvas'),
        context   = theCanvas.getContext('2d');

    document.body.appendChild(theCanvas);
    theCanvas.width = screen.width;
    theCanvas.height = screen.height;

    function setLinePoints ( iterations ) {
        var pointList = {first: {x: 0, y: 1}},
            minY      = 1,
            maxY      = 1,
            point, nextPoint, ind, dx, newX, newY, newPoint, normalizeRate;

        pointList.first.next = {x: 1, y: 1};
        for ( ind = 0; ind < iterations; ind++ ) {
            point = pointList.first;
            while ( point.next != null ) { // eslint-disable-line
                nextPoint = point.next;

                dx = nextPoint.x - point.x;
                newX = 0.5 * (point.x + nextPoint.x);
                newY = 0.5 * (point.y + nextPoint.y);
                newY += dx * ((Math.random() * 2) - 1);

                newPoint = {x: newX, y: newY};

                // min, max
                if ( newY < minY ) {
                    minY = newY;
                } else if ( newY > maxY ) {
                    maxY = newY;
                }

                // put between points
                newPoint.next = nextPoint;
                point.next = newPoint;
                point = nextPoint;
            }
        }

        if ( maxY === minY ) {
            // unlikely that max = min, but could happen if using zero iterations. In this case, set all points equal to 1.
            point = pointList.first;
            while ( point !== null ) {
                point.y = 1;
                point = point.next;
            }
        } else {
            // normalize to values between 0 and 1
            normalizeRate = 1 / (maxY - minY);
            point = pointList.first;
            while ( point != null ) { // eslint-disable-line
                point.y = normalizeRate * (point.y - minY);
                point = point.next;
            }
        }

        return pointList;
    }

    function drawCircle ( centerX, centerY, minRad, maxRad, phase, color ) {
        var twoPi     = 2 * Math.PI,
            // generate the random function that will be used to vary the radius, 9 iterations of subdivision
            pointList = setLinePoints(9),
            point, rad, theta, x0, y0;

        context.strokeStyle = color;
        context.lineWidth = 1;
        context.fillStyle = color;
        context.beginPath();
        point = pointList.first;
        theta = phase;
        rad = minRad + (point.y * (maxRad - minRad));
        x0 = centerX + (rad * Math.cos(theta));
        y0 = centerY + (rad * Math.sin(theta));
        context.lineTo(x0, y0);
        while ( point.next != null ) { // eslint-disable-line
            point = point.next;
            theta = (twoPi * point.x) + phase;
            rad = minRad + (point.y * (maxRad - minRad));
            x0 = centerX + (rad * Math.cos(theta));
            y0 = centerY + (rad * Math.sin(theta));
            context.lineTo(x0, y0);
        }
        context.stroke();
        context.fill();
    }

    function generate () {
        var red, green, blue, alpha, ind, centerX, centerY,
            color, maxRad, minRad, phase;

        for ( ind = 0; ind < 1; ind++ ) {
            maxRad = 50 + (Math.random() * 50);
            minRad = 0.88 * maxRad;

            centerX = maxRad + (Math.random() * (screen.width - (2 * maxRad)));
            centerY = maxRad + (Math.random() * (screen.height - (2 * maxRad)));

            red = Math.floor(Math.random() * 255);
            green = Math.floor(Math.random() * 255);
            blue = Math.floor(Math.random() * 255);
            alpha = 0.4;
            color = 'rgba(' + red + ',' + green + ',' + blue + ',' + alpha + ')';

            phase = Math.random() * Math.PI * 2;

            drawCircle(centerX, centerY, minRad, maxRad, phase, color);
        }
    }

    function init () {
        generate();
        setInterval(function () {
            generate();
        }, 1000);
    }

    init();
}

// dom is ready
window.onload = function () {
    canvasApp();
};

// mouse click
window.onclick = function () { return false; };

// prevent default right-click menu only for releases
window.oncontextmenu = function () {
    return false;
};
